import { customElement, computedFrom } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { Rule, ValidationRules } from 'aurelia-validation';
import { DeviationRequestBase } from 'model/forms/deviation-request';
import { KeywordsService } from 'services/keywords-service';
import { UserInfo } from '../model/business-base';
import { DeviationTeamType } from '../model/business-enums';

@customElement('deviation-request-epra-panel')
export class DeviationRequestEpraPanelCustomElement {
  @bindable model: DeviationRequestBase;
  @bindable disabled: boolean;
  epraPanelRules: Rule<DeviationRequestBase, any>[][];

  constructor(protected keywords: KeywordsService) {
  }

  modelChanged() {
    this.epraPanelRules = ValidationRules
      .ensureObject<DeviationRequestBase>().required()
      .ensure(model => model.epra).displayName('Entity Person Responsible for Aviation (EPRA)').required()
      //.ensure(model => model.isSupportedByEpra).equals(true).withMessage('Approval from your EPRA is mandatory.') //does not work, workaround validation in SingleInstanceDeviationRequestFormCustomElement
      .rules;
  }

  @computedFrom('model')
  get aviationDeviationTeamUsers(): UserInfo[] {
    return this.keywords.getDeviationTeam(DeviationTeamType.Aviation).members;
  }

  keywordsItemMatcher = this.keywords.itemsMatch;
}
